import SkypeNotificationType from '../store/schema/SkypeNotificationType';
import { SkypeNotificationOptions } from 'owa-outlook-service-options';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('updateSkypeUserOption', function updateSkypeUserOption(
    userOptions: SkypeNotificationOptions,
    setting: 'skypeCallingNotification' | 'skypeMessageNotification',
    notificationType: SkypeNotificationType
) {
    userOptions[setting] = notificationType as number;
});
